import React, { useEffect } from "react";
import { COMPANY_CONTACT } from "../../constants/data";

export default function ProductDetailModal({ product, onClose, onToggleFavorite, isFavorite }) {
  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  if (!product) return null;

  const nutrition = product.nutrition || {};
  const machines = product.machines || (product.location ? [product.location] : ["Máquinas Central Campus Universitario"]);
  const pills = product.pills || (product.tag ? [product.tag] : []);

  const whatsappMessage = encodeURIComponent(
    `¡Hola VittaLink! Me interesa el producto "${product.name}" que vi en su catálogo web de máquinas expendedoras. ¿En qué máquinas está disponible actualmente?`
  );

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
        backgroundColor: "rgba(15, 35, 23, 0.65)",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
        animation: "fadeIn 0.22s ease-out"
      }}
      onClick={onClose}
    >
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes modalPop {
          from { transform: translateY(24px) scale(0.97); opacity: 0; }
          to { transform: translateY(0) scale(1); opacity: 1; }
        }
        .light-scroll::-webkit-scrollbar {
          width: 6px;
        }
        .light-scroll::-webkit-scrollbar-track {
          background: #f1f5f2;
        }
        .light-scroll::-webkit-scrollbar-thumb {
          background: #86efac;
          border-radius: 99px;
        }
        .light-scroll::-webkit-scrollbar-thumb:hover {
          background: #22c55e;
        }
        @media (max-width: 820px) {
          .pmodal-grid {
            grid-template-columns: 1fr !important;
          }
          .pmodal-img-col {
            border-right: none !important;
            border-bottom: 1px solid #eef3ee !important;
          }
        }
      `}</style>

      <div
        className="light-scroll"
        style={{
          position: "relative",
          width: "min(960px, 98%)",
          maxHeight: "90vh",
          overflowY: "auto",
          backgroundColor: "#ffffff",
          borderRadius: 28,
          border: "1px solid #e2ece3",
          boxShadow: "0 25px 65px rgba(16, 50, 28, 0.18), 0 0 1px rgba(0,0,0,0.1)",
          color: "#0f2317",
          animation: "modalPop 0.28s cubic-bezier(0.16, 1, 0.3, 1)",
          padding: 0
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Top Close Button */}
        <button
          onClick={onClose}
          aria-label="Cerrar modal"
          style={{
            position: "absolute",
            top: 18,
            right: 18,
            zIndex: 10,
            width: 38,
            height: 38,
            borderRadius: "50%",
            backgroundColor: "#f1f5f2",
            border: "1px solid #e2ece3",
            color: "#1e3a29",
            fontSize: "16px",
            display: "grid",
            placeItems: "center",
            cursor: "pointer",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#e2ece3";
            e.currentTarget.style.transform = "rotate(90deg)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#f1f5f2";
            e.currentTarget.style.transform = "rotate(0deg)";
          }}
        >
          ✕
        </button>

        {/* Modal Layout Grid */}
        <div
          className="pmodal-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1.08fr 1.32fr",
            gap: 0
          }}
        >
          {/* Left Column: Image, Tags & Machine Pin */}
          <div
            className="pmodal-img-col"
            style={{
              padding: "32px",
              backgroundColor: "#f7faf7",
              borderRight: "1px solid #e8f0e9",
              display: "flex",
              flexDirection: "column",
              gap: "20px"
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                aspectRatio: "1/1.02",
                borderRadius: 22,
                overflow: "hidden",
                backgroundColor: "#ffffff",
                border: "1px solid #e2ece3",
                boxShadow: "0 8px 24px rgba(22, 60, 35, 0.06)"
              }}
            >
              <img
                src={product.img}
                alt={product.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover"
                }}
                onError={(e) => {
                  e.target.src = "/catalog/hero.jpg";
                }}
              />

              {/* Badge */}
              {product.badge && (
                <div
                  style={{
                    position: "absolute",
                    top: 14,
                    left: 14,
                    backgroundColor: "#bbf7d0",
                    color: "#14532d",
                    border: "1px solid #86efac",
                    padding: "5px 12px",
                    borderRadius: 9999,
                    fontSize: "11px",
                    fontWeight: 800,
                    letterSpacing: "0.04em",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px"
                  }}
                >
                  <span>★</span> {product.badge}
                </div>
              )}

              {/* Favorite Button */}
              {onToggleFavorite && (
                <button
                  type="button"
                  onClick={() => onToggleFavorite(product.id)}
                  style={{
                    position: "absolute",
                    top: 14,
                    right: 14,
                    width: 36,
                    height: 36,
                    borderRadius: "50%",
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    border: "1px solid #e2ece3",
                    display: "grid",
                    placeItems: "center",
                    cursor: "pointer",
                    fontSize: "17px",
                    color: isFavorite ? "#ef4444" : "#94a3b8",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.06)"
                  }}
                >
                  {isFavorite ? "♥" : "♡"}
                </button>
              )}

              {/* Pills in image bottom */}
              <div
                style={{
                  position: "absolute",
                  bottom: 12,
                  left: 12,
                  display: "flex",
                  gap: "6px",
                  flexWrap: "wrap"
                }}
              >
                {pills.map((pill, idx) => (
                  <span
                    key={idx}
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.95)",
                      color: "#166534",
                      border: "1px solid #bbf7d0",
                      padding: "4px 10px",
                      borderRadius: 9999,
                      fontSize: "11px",
                      fontWeight: 700,
                      backdropFilter: "blur(6px)"
                    }}
                  >
                    {pill}
                  </span>
                ))}
              </div>
            </div>

            {/* Product Rating */}
            <div
              style={{
                padding: "16px 20px",
                borderRadius: 18,
                backgroundColor: "#ffffff",
                border: "1px solid #e2ece3",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "0 4px 16px rgba(22, 60, 35, 0.04)"
              }}
            >
              <div>
                <span style={{ fontSize: "11px", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", fontWeight: 700 }}>
                  Valoración del producto
                </span>
                <div aria-label={`${Number(product.rating ?? 5).toFixed(1)} de 5 estrellas`} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: "24px", fontWeight: 900, color: "#14532d", letterSpacing: "-0.02em" }}>
                  <span style={{ color: "#eab308", letterSpacing: 2 }}>{Array.from({ length: 5 }, (_, i) => i < Math.round(Number(product.rating ?? 5)) ? "★" : "☆").join("")}</span>
                  <span>{Number(product.rating ?? 5).toFixed(1)}<small style={{ color: "#64748b", fontSize: 13, fontWeight: 600 }}> / 5</small></span>
                </div>
              </div>

              {product.spiral && (
                <div
                  style={{
                    textAlign: "right",
                    backgroundColor: "#f0fdf4",
                    padding: "8px 14px",
                    borderRadius: 12,
                    border: "1px solid #bbf7d0"
                  }}
                >
                  <div style={{ fontSize: "10px", color: "#166534", fontWeight: 700 }}>CÓDIGO DISPENSADOR</div>
                  <div style={{ fontSize: "16px", fontWeight: 800, color: "#14532d" }}>
                    Espiral {product.spiral}
                  </div>
                </div>
              )}
            </div>

            {/* Vending Availability Card */}
            <div
              style={{
                padding: "16px",
                borderRadius: 18,
                backgroundColor: "#ffffff",
                border: "1px solid #e2ece3"
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
                <span style={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#16a34a" }} />
                <span style={{ fontSize: "12px", fontWeight: 800, color: "#14532d", letterSpacing: "0.04em" }}>
                  DISPONIBLE EN MÁQUINAS:
                </span>
              </div>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "6px" }}>
                {machines.map((m, idx) => (
                  <li
                    key={idx}
                    style={{
                      fontSize: "12.5px",
                      color: "#475569",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px"
                    }}
                  >
                    <span style={{ color: "#16a34a" }}>📍</span> {m}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right Column: Full Details, Nutrition & Ingredients */}
          <div
            style={{
              padding: "36px 32px 32px",
              display: "flex",
              flexDirection: "column",
              gap: "24px"
            }}
          >
            {/* Header info */}
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
                <span
                  style={{
                    fontSize: "11px",
                    fontWeight: 800,
                    color: "#166534",
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    backgroundColor: "#f0fdf4",
                    border: "1px solid #bbf7d0",
                    padding: "3px 10px",
                    borderRadius: 9999
                  }}
                >
                  {product.category || "Vending Snack"}
                </span>
              </div>

              <h2
                style={{
                  fontSize: "clamp(24px, 3.2vw, 32px)",
                  fontWeight: 900,
                  color: "#0f291e",
                  letterSpacing: "-0.03em",
                  lineHeight: 1.15,
                  margin: "6px 0 10px"
                }}
              >
                {product.name}
              </h2>

              <p style={{ fontSize: "14.5px", color: "#475569", lineHeight: 1.65 }}>
                {product.description || product.shortDesc}
              </p>
            </div>

            {/* TABLA NUTRICIONAL DETALLADA */}
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "12px",
                  borderBottom: "1px solid #eef3ee",
                  paddingBottom: "8px"
                }}
              >
                <h3 style={{ fontSize: "13px", fontWeight: 800, color: "#14532d", letterSpacing: "0.06em", textTransform: "uppercase" }}>
                  Información Nutricional (Por Porción)
                </h3>
                <span style={{ fontSize: "11.5px", color: "#94a3b8" }}>Valores certificados</span>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(105px, 1fr))",
                  gap: "10px"
                }}
              >
                <div
                  style={{
                    backgroundColor: "#f8faf8",
                    padding: "12px",
                    borderRadius: 14,
                    border: "1px solid #eef3ee",
                    textAlign: "center"
                  }}
                >
                  <span style={{ fontSize: "11px", color: "#64748b" }}>Calorías</span>
                  <div style={{ fontSize: "17px", fontWeight: 800, color: "#0f291e", marginTop: "3px" }}>
                    {nutrition.calories || "—"}
                  </div>
                </div>

                <div
                  style={{
                    backgroundColor: "#f0fdf4",
                    padding: "12px",
                    borderRadius: 14,
                    border: "1px solid #bbf7d0",
                    textAlign: "center"
                  }}
                >
                  <span style={{ fontSize: "11px", color: "#166534", fontWeight: 700 }}>Proteínas</span>
                  <div style={{ fontSize: "17px", fontWeight: 800, color: "#15803d", marginTop: "3px" }}>
                    {nutrition.protein || "—"}
                  </div>
                </div>

                <div
                  style={{
                    backgroundColor: "#f8faf8",
                    padding: "12px",
                    borderRadius: 14,
                    border: "1px solid #eef3ee",
                    textAlign: "center"
                  }}
                >
                  <span style={{ fontSize: "11px", color: "#64748b" }}>Carbs</span>
                  <div style={{ fontSize: "17px", fontWeight: 800, color: "#0f291e", marginTop: "3px" }}>
                    {nutrition.carbs || "—"}
                  </div>
                </div>

                <div
                  style={{
                    backgroundColor: "#f8faf8",
                    padding: "12px",
                    borderRadius: 14,
                    border: "1px solid #eef3ee",
                    textAlign: "center"
                  }}
                >
                  <span style={{ fontSize: "11px", color: "#64748b" }}>Grasas Sal.</span>
                  <div style={{ fontSize: "17px", fontWeight: 800, color: "#0f291e", marginTop: "3px" }}>
                    {nutrition.fats || "—"}
                  </div>
                </div>

                <div
                  style={{
                    backgroundColor: "#f8faf8",
                    padding: "12px",
                    borderRadius: 14,
                    border: "1px solid #eef3ee",
                    textAlign: "center"
                  }}
                >
                  <span style={{ fontSize: "11px", color: "#64748b" }}>Azúcares</span>
                  <div style={{ fontSize: "17px", fontWeight: 800, color: "#0f291e", marginTop: "3px" }}>
                    {nutrition.sugars || "—"}
                  </div>
                </div>

                <div
                  style={{
                    backgroundColor: "#f8faf8",
                    padding: "12px",
                    borderRadius: 14,
                    border: "1px solid #eef3ee",
                    textAlign: "center"
                  }}
                >
                  <span style={{ fontSize: "11px", color: "#64748b" }}>Fibra</span>
                  <div style={{ fontSize: "17px", fontWeight: 800, color: "#0f291e", marginTop: "3px" }}>
                    {nutrition.fiber || "—"}
                  </div>
                </div>
              </div>
            </div>

            {/* INGREDIENTES & ALÉRGENOS */}
            <div
              style={{
                backgroundColor: "#f7faf7",
                padding: "18px",
                borderRadius: 18,
                border: "1px solid #e8f0e9",
                display: "flex",
                flexDirection: "column",
                gap: "10px"
              }}
            >
              <div>
                <span style={{ fontSize: "11px", fontWeight: 800, color: "#166534", letterSpacing: "0.06em", textTransform: "uppercase" }}>
                  🌿 Ingredientes Reales
                </span>
                <p style={{ fontSize: "13px", color: "#475569", lineHeight: 1.55, marginTop: "4px", margin: 0 }}>
                  {product.ingredients || "Ingredientes 100% de origen natural seleccionados para nutrición limpia."}
                </p>
              </div>

              {product.allergens && (
                <div style={{ borderTop: "1px solid #e2ece3", paddingTop: "8px" }}>
                  <span style={{ fontSize: "11px", fontWeight: 800, color: "#b45309", letterSpacing: "0.06em", textTransform: "uppercase" }}>
                    ⚠️ Alérgenos & Restricciones
                  </span>
                  <p style={{ fontSize: "12.5px", color: "#475569", marginTop: "2px", margin: 0 }}>
                    {product.allergens}
                  </p>
                </div>
              )}
            </div>

            {/* ACTION BUTTONS */}
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginTop: "auto", paddingTop: "6px" }}>
              <a
                href={`https://wa.me/${COMPANY_CONTACT.whatsappNumber}?text=${whatsappMessage}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  flex: "1 1 240px",
                  backgroundColor: "#166534",
                  color: "#ffffff",
                  padding: "14px 24px",
                  borderRadius: 9999,
                  fontWeight: 800,
                  fontSize: "14px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  boxShadow: "0 8px 20px rgba(22, 101, 52, 0.25)",
                  transition: "all 0.2s ease",
                  textDecoration: "none"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#15803d";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#166534";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <span>💬</span> Consultar Disponibilidad por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
